import {
  Bleed,
  BlockStack,
  Box,
  Card,
  Grid,
  InlineGrid,
  Layout,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
  SkeletonPageProps,
  Text,
  useBreakpoints,
} from '@shopify/polaris'
import OverviewCard from '@Shared/components/OverviewCard.tsx'
import { useTranslation } from 'react-i18next'
import GoToPrisync from '@Shared/components/GoToPrisync.tsx'

function SkeletonPageLoader({ ...props }: SkeletonPageProps): JSX.Element {
  const { xlDown } = useBreakpoints()
  const { t: translate } = useTranslation()

  return (
    <Bleed marginBlockStart="400">
      <SkeletonPage
        title={translate('Prisync.overview.label')}
        fullWidth={xlDown}
        primaryAction
        {...props}
      >
        <Layout>
          <Layout.Section>
            <Grid columns={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3 }}>
              <Grid.Cell columnSpan={{ xs: 1, sm: 2, md: 1, lg: 1, xl: 1 }}>
                <OverviewCard
                  title={translate('Prisync.overview.cards.summary.title')}
                >
                  <SkeletonDisplayText />
                  <SkeletonBodyText />
                </OverviewCard>
              </Grid.Cell>
              <Grid.Cell>
                <OverviewCard
                  title={translate('Prisync.overview.cards.dpRules.title')}
                >
                  <SkeletonDisplayText />
                  <SkeletonBodyText />
                </OverviewCard>
              </Grid.Cell>
              <Grid.Cell>
                <OverviewCard
                  title={translate('Prisync.overview.cards.oufOfStock.title')}
                  tooltip={{
                    enabled: false,
                  }}
                  primaryAction={
                    <Text as={'span'} variant={'bodyMd'}>
                      # of Products
                    </Text>
                  }
                >
                  <SkeletonDisplayText />
                  <SkeletonBodyText />
                </OverviewCard>
              </Grid.Cell>
              <Grid.Cell columnSpan={{ xs: 1, sm: 2, md: 1, lg: 1, xl: 1 }}>
                <OverviewCard>
                  <SkeletonDisplayText />
                  <SkeletonBodyText />
                </OverviewCard>
              </Grid.Cell>
              <Grid.Cell columnSpan={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2 }}>
                <OverviewCard>
                  <SkeletonDisplayText />
                  <SkeletonBodyText />
                </OverviewCard>
              </Grid.Cell>
              <Grid.Cell columnSpan={{ sm: 2, md: 3, lg: 3, xl: 3 }}>
                <OverviewCard>
                  <SkeletonDisplayText />
                  <SkeletonBodyText />
                </OverviewCard>
              </Grid.Cell>
              <Grid.Cell columnSpan={{ sm: 3, md: 3, lg: 3, xl: 3 }}>
                <Card>
                  <Box
                    padding={'400'}
                    background={'bg-surface-secondary'}
                    borderRadius={'100'}
                  >
                    <BlockStack gap={'200'}>
                      <Text as={'h2'} variant={'headingMd'}>
                        {translate(
                          'Prisync.overview.cards.productDetails.title',
                        )}
                      </Text>
                      <InlineGrid columns={6} alignItems={'start'} gap={'400'}>
                        <Grid.Cell columnSpan={{ xs: 5 }}>
                          <Text as={'p'} variant={'bodyMd'}>
                            {translate(
                              'Prisync.overview.cards.productDetails.description',
                            )}
                          </Text>
                        </Grid.Cell>
                        <GoToPrisync
                          label={translate(
                            'Prisync.overview.cards.productDetails.action',
                          )}
                          variant={'primary'}
                          redirect={'products'}
                        />
                      </InlineGrid>
                    </BlockStack>
                  </Box>
                </Card>
              </Grid.Cell>
            </Grid>
          </Layout.Section>
        </Layout>
      </SkeletonPage>
    </Bleed>
  )
}

export default SkeletonPageLoader
